<template>
  <div>
    {{ itemsLoading }}
    <br>
    <br>
    <br>
    <ul id="example-1">
      <li v-for="item in getItemsByLevel" v-bind:key=item.id>
        <Button nupsi>{{ item.name }}</Button>
        <ul>
          <li v-for="subItem in getItemsByParentId(item.id)" v-bind:key=subItem.id>
            {{ subItem.name }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import Button from '../atoms/Button'

const { mapFields } = createHelpers({
  getterType: 'users/getCategoriesByLevel',
  mutationType: 'users/updateField'
})

export default {
  name: 'Categories.vue',
  components: { Button },
  data () {
    return {
    }
  }
}

</script>

<style scoped>

</style>
